import { Component, Input, OnInit } from "@angular/core";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { filter, map } from "rxjs/operators";
import { PublicConfigService } from "src/app/shared/services/public.config.service";
import { DateTime } from "luxon";

@Component({
  selector: 'widget-news',
  templateUrl: './widget-news.component.html',
  styleUrls: ['./widget-news.component.scss']
})
export class WidgetNewsComponent implements OnInit {
  @Input() widgetConfig;

  clientId: string = "";
  newsItems: any[] = [];
  newsItemsLimit: number = 1;

  FEUrl: string = '';

  loading: boolean = true;

  constructor(
    private publicConfig: PublicConfigService,
    private db: AngularFirestore,
  ) { }

  async ngOnInit() {
    this.FEUrl = this.publicConfig.feBaseUrl;

    const { ssoClientId } = this.publicConfig.getCarrotSSOConfig();
    this.clientId = ssoClientId;

    this.newsItemsLimit = this.widgetConfig.widgetSettings.newsItemsLimit;

    const query = this.db.collection('clientAssets', ref => ref
      .where('clientId', '==', this.clientId)
      .where('assetType', '==', 'NewsItem')
      .orderBy('data.fieldData.date', 'desc')
      .limit(this.newsItemsLimit));

    // TODO - how many calls does this make?
    // optimize?
    const snapshot = query.get().subscribe(resp => {
      resp.forEach(doc => {
        let newsData: any = doc.data();
        if (!newsData.data.isDraft && !newsData.data.isArchived) {
          this.newsItems.push(newsData);
        }
      });

      // update the date of the news item to be shown in a meaningful way
      this.newsItems.forEach(element => {
        if (element.data.fieldData.date) {
          element.compiledDate = DateTime.fromISO(element.data.fieldData.date).toFormat('MMMM dd, yyyy');
        } else {
          element.compiledDate = '';
        }
      });
      
      this.loading = false;
    });
  }
}
